/**
 * Auto-generated by scripts/generate-drizzle-schema.mjs
 * Regenerate with: make generate-schema
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const activity_recent = sqliteTable(
  "activity_recent",
  {
    id: text("id").primaryKey(),
    scope_id: text("scope_id"),
    entity_type: text("entity_type"),
    entity_id: text("entity_id"),
    action: text("action"),
    actor_user_id: text("actor_user_id"),
    actor_name: text("actor_name"),
    actor_device_id: text("actor_device_id"),
    platform: text("platform"),
    server_ts: text("server_ts"),
    client_ts: text("client_ts"),
    patch: text("patch"),
    batch_id: text("batch_id"),
    reverts_activity_id: text("reverts_activity_id"),
  },
  (table) => [
    /** ORDER BY server_ts DESC en el feed de actividad */
    index("activity_recent_by_feed").on(table.server_ts),
    /** WHERE entity_type = ? AND entity_id = ? en el historial por entidad */
    index("activity_recent_by_entity").on(table.entity_type, table.entity_id, table.server_ts),
  ],
);

export const attachment = sqliteTable(
  "attachment",
  {
    id: text("id").primaryKey(),
    filename: text("filename"),
    content_type: text("content_type"),
    size: integer("size"),
    url: text("url"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
    hash: text("hash"),
    owner_id: text("owner_id"),
  },
  (table) => [
    /** WHERE owner_id = ? ORDER BY created_at en useAttachments */
    index("attachment_by_owner").on(table.owner_id, table.created_at),
    /** WHERE user_id = ? en getHasLocalDataQuery */
    index("attachment_by_user").on(table.user_id),
  ],
);

export const bill_of_materials = sqliteTable("bill_of_materials", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  product_id: text("product_id"),
  qty: integer("qty"),
  reference: text("reference"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const bom_component = sqliteTable("bom_component", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  bom_id: text("bom_id"),
  product_id: text("product_id"),
  qty: integer("qty"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

export const inventory_count = sqliteTable("inventory_count", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  location_id: text("location_id"),
  state: text("state"),
  reference: text("reference"),
  note: text("note"),
  done_at: text("done_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const inventory_count_line = sqliteTable(
  "inventory_count_line",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    count_id: text("count_id"),
    product_id: text("product_id"),
    lot_id: text("lot_id"),
    theoretical_qty: integer("theoretical_qty"),
    counted_qty: integer("counted_qty"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE count_id = ? en las líneas del conteo */
    index("inventory_count_line_by_count").on(table.count_id),
  ],
);

export const landed_cost = sqliteTable("landed_cost", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  picking_id: text("picking_id"),
  amount: integer("amount"),
  state: text("state"),
  reference: text("reference"),
  note: text("note"),
  done_at: text("done_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const landed_cost_line = sqliteTable("landed_cost_line", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  landed_cost_id: text("landed_cost_id"),
  product_id: text("product_id"),
  valuation_layer_id: text("valuation_layer_id"),
  amount: integer("amount"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const location = sqliteTable("location", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  warehouse_id: text("warehouse_id"),
  parent_id: text("parent_id"),
  name: text("name"),
  code: text("code"),
  usage: text("usage"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const lot = sqliteTable(
  "lot",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    product_id: text("product_id"),
    name: text("name"),
    expiry_date: text("expiry_date"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE product_id = ? ORDER BY expiry_date (FEFO) */
    index("lot_by_product").on(table.product_id, table.expiry_date),
  ],
);

export const manufacturing_order = sqliteTable("manufacturing_order", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  bom_id: text("bom_id"),
  product_id: text("product_id"),
  qty: integer("qty"),
  location_id: text("location_id"),
  state: text("state"),
  reference: text("reference"),
  note: text("note"),
  produced_cost: integer("produced_cost"),
  done_at: text("done_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

// Dataset pequeño por usuario — índices no necesarios por ahora.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Dataset pequeño — índices no necesarios por ahora.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

export const product = sqliteTable("product", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  sku: text("sku"),
  name: text("name"),
  kind: text("kind"),
  category_id: text("category_id"),
  uom_id: text("uom_id"),
  barcode: text("barcode"),
  std_cost: integer("std_cost"),
  active: integer("active"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  tracking: text("tracking"),
  is_kit: integer("is_kit"),
  deleted_at: text("deleted_at"),
});

export const product_category = sqliteTable("product_category", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  parent_id: text("parent_id"),
  name: text("name"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const product_supplier = sqliteTable("product_supplier", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  product_id: text("product_id"),
  vendor_id: text("vendor_id"),
  vendor_code: text("vendor_code"),
  price: integer("price"),
  min_qty: integer("min_qty"),
  lead_time_days: integer("lead_time_days"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const purchase_order = sqliteTable("purchase_order", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  vendor_id: text("vendor_id"),
  warehouse_id: text("warehouse_id"),
  dst_location_id: text("dst_location_id"),
  state: text("state"),
  reference: text("reference"),
  note: text("note"),
  confirmed_at: text("confirmed_at"),
  received_at: text("received_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const purchase_order_line = sqliteTable("purchase_order_line", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  po_id: text("po_id"),
  product_id: text("product_id"),
  qty: integer("qty"),
  price: integer("price"),
  received_qty: integer("received_qty"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const purchase_return = sqliteTable("purchase_return", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  po_id: text("po_id"),
  src_location_id: text("src_location_id"),
  warehouse_id: text("warehouse_id"),
  state: text("state"),
  reference: text("reference"),
  note: text("note"),
  done_at: text("done_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const purchase_return_line = sqliteTable("purchase_return_line", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  return_id: text("return_id"),
  product_id: text("product_id"),
  qty: integer("qty"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const reorder_rule = sqliteTable("reorder_rule", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  product_id: text("product_id"),
  warehouse_id: text("warehouse_id"),
  min_qty: integer("min_qty"),
  max_qty: integer("max_qty"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

// Sesiones activas del usuario — dataset pequeño, sin índices.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
  expires_at: text("expires_at"),
  token: text("token"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  ip_address: text("ip_address"),
  user_agent: text("user_agent"),
  user_id: text("user_id"),
  active_organization_id: text("active_organization_id"),
  device_id: text("device_id"),
});

export const stock_move = sqliteTable("stock_move", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  product_id: text("product_id"),
  src_location_id: text("src_location_id"),
  dst_location_id: text("dst_location_id"),
  qty: integer("qty"),
  reason: text("reason"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  picking_id: text("picking_id"),
  lot_id: text("lot_id"),
  note: text("note"),
});

export const stock_move_line = sqliteTable("stock_move_line", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  picking_id: text("picking_id"),
  product_id: text("product_id"),
  src_location_id: text("src_location_id"),
  dst_location_id: text("dst_location_id"),
  qty: integer("qty"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  lot_id: text("lot_id"),
});

export const stock_picking = sqliteTable("stock_picking", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  kind: text("kind"),
  state: text("state"),
  reference: text("reference"),
  warehouse_id: text("warehouse_id"),
  src_location_id: text("src_location_id"),
  dst_location_id: text("dst_location_id"),
  note: text("note"),
  done_at: text("done_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const stock_quant = sqliteTable("stock_quant", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  product_id: text("product_id"),
  location_id: text("location_id"),
  qty: integer("qty"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  lot_id: text("lot_id"),
});

// Dataset global pequeño (~20 temas) — índices no necesarios.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

export const uom = sqliteTable("uom", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  category: text("category"),
  factor: integer("factor"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

// Solo 1 fila por usuario — índices no necesarios.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
  banned: integer("banned"),
  ban_reason: text("ban_reason"),
  ban_expires: text("ban_expires"),
  two_factor_enabled: integer("two_factor_enabled"),
  two_factor_secret: text("two_factor_secret"),
  two_factor_backup_codes: text("two_factor_backup_codes"),
  deletion_requested_at: text("deletion_requested_at"),
});

export const valuation_layer = sqliteTable("valuation_layer", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  product_id: text("product_id"),
  move_id: text("move_id"),
  warehouse_id: text("warehouse_id"),
  qty: integer("qty"),
  unit_cost: integer("unit_cost"),
  value: integer("value"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const vendor = sqliteTable("vendor", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  email: text("email"),
  phone: text("phone"),
  lead_time_days: integer("lead_time_days"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const warehouse = sqliteTable("warehouse", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  code: text("code"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const drizzleSchema = {
  activity_recent,
  attachment,
  bill_of_materials,
  bom_component,
  font_family,
  font_variant,
  inventory_count,
  inventory_count_line,
  landed_cost,
  landed_cost_line,
  location,
  lot,
  manufacturing_order,
  member,
  organization,
  product,
  product_category,
  product_supplier,
  purchase_order,
  purchase_order_line,
  purchase_return,
  purchase_return_line,
  reorder_rule,
  session,
  stock_move,
  stock_move_line,
  stock_picking,
  stock_quant,
  themes,
  uom,
  user,
  valuation_layer,
  vendor,
  warehouse,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = ["attachment"] as const;

export type ActivityRecent = InferSelectModel<typeof activity_recent>;
export type ActivityRecentInsert = InferInsertModel<typeof activity_recent>;
export type ActivityRecentRecord = ActivityRecent;
export type Attachment = InferSelectModel<typeof attachment>;
export type AttachmentInsert = InferInsertModel<typeof attachment>;
export type AttachmentRecord = Attachment;
export type BillOfMaterials = InferSelectModel<typeof bill_of_materials>;
export type BillOfMaterialsInsert = InferInsertModel<typeof bill_of_materials>;
export type BillOfMaterialsRecord = BillOfMaterials;
export type BomComponent = InferSelectModel<typeof bom_component>;
export type BomComponentInsert = InferInsertModel<typeof bom_component>;
export type BomComponentRecord = BomComponent;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type InventoryCount = InferSelectModel<typeof inventory_count>;
export type InventoryCountInsert = InferInsertModel<typeof inventory_count>;
export type InventoryCountRecord = InventoryCount;
export type InventoryCountLine = InferSelectModel<typeof inventory_count_line>;
export type InventoryCountLineInsert = InferInsertModel<typeof inventory_count_line>;
export type InventoryCountLineRecord = InventoryCountLine;
export type LandedCost = InferSelectModel<typeof landed_cost>;
export type LandedCostInsert = InferInsertModel<typeof landed_cost>;
export type LandedCostRecord = LandedCost;
export type LandedCostLine = InferSelectModel<typeof landed_cost_line>;
export type LandedCostLineInsert = InferInsertModel<typeof landed_cost_line>;
export type LandedCostLineRecord = LandedCostLine;
export type Location = InferSelectModel<typeof location>;
export type LocationInsert = InferInsertModel<typeof location>;
export type LocationRecord = Location;
export type Lot = InferSelectModel<typeof lot>;
export type LotInsert = InferInsertModel<typeof lot>;
export type LotRecord = Lot;
export type ManufacturingOrder = InferSelectModel<typeof manufacturing_order>;
export type ManufacturingOrderInsert = InferInsertModel<typeof manufacturing_order>;
export type ManufacturingOrderRecord = ManufacturingOrder;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Product = InferSelectModel<typeof product>;
export type ProductInsert = InferInsertModel<typeof product>;
export type ProductRecord = Product;
export type ProductCategory = InferSelectModel<typeof product_category>;
export type ProductCategoryInsert = InferInsertModel<typeof product_category>;
export type ProductCategoryRecord = ProductCategory;
export type ProductSupplier = InferSelectModel<typeof product_supplier>;
export type ProductSupplierInsert = InferInsertModel<typeof product_supplier>;
export type ProductSupplierRecord = ProductSupplier;
export type PurchaseOrder = InferSelectModel<typeof purchase_order>;
export type PurchaseOrderInsert = InferInsertModel<typeof purchase_order>;
export type PurchaseOrderRecord = PurchaseOrder;
export type PurchaseOrderLine = InferSelectModel<typeof purchase_order_line>;
export type PurchaseOrderLineInsert = InferInsertModel<typeof purchase_order_line>;
export type PurchaseOrderLineRecord = PurchaseOrderLine;
export type PurchaseReturn = InferSelectModel<typeof purchase_return>;
export type PurchaseReturnInsert = InferInsertModel<typeof purchase_return>;
export type PurchaseReturnRecord = PurchaseReturn;
export type PurchaseReturnLine = InferSelectModel<typeof purchase_return_line>;
export type PurchaseReturnLineInsert = InferInsertModel<typeof purchase_return_line>;
export type PurchaseReturnLineRecord = PurchaseReturnLine;
export type ReorderRule = InferSelectModel<typeof reorder_rule>;
export type ReorderRuleInsert = InferInsertModel<typeof reorder_rule>;
export type ReorderRuleRecord = ReorderRule;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type StockMove = InferSelectModel<typeof stock_move>;
export type StockMoveInsert = InferInsertModel<typeof stock_move>;
export type StockMoveRecord = StockMove;
export type StockMoveLine = InferSelectModel<typeof stock_move_line>;
export type StockMoveLineInsert = InferInsertModel<typeof stock_move_line>;
export type StockMoveLineRecord = StockMoveLine;
export type StockPicking = InferSelectModel<typeof stock_picking>;
export type StockPickingInsert = InferInsertModel<typeof stock_picking>;
export type StockPickingRecord = StockPicking;
export type StockQuant = InferSelectModel<typeof stock_quant>;
export type StockQuantInsert = InferInsertModel<typeof stock_quant>;
export type StockQuantRecord = StockQuant;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type Uom = InferSelectModel<typeof uom>;
export type UomInsert = InferInsertModel<typeof uom>;
export type UomRecord = Uom;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
export type ValuationLayer = InferSelectModel<typeof valuation_layer>;
export type ValuationLayerInsert = InferInsertModel<typeof valuation_layer>;
export type ValuationLayerRecord = ValuationLayer;
export type Vendor = InferSelectModel<typeof vendor>;
export type VendorInsert = InferInsertModel<typeof vendor>;
export type VendorRecord = Vendor;
export type Warehouse = InferSelectModel<typeof warehouse>;
export type WarehouseInsert = InferInsertModel<typeof warehouse>;
export type WarehouseRecord = Warehouse;
